<template>
  <div class="map-tool-window-header" :id="headerId">
    <span class="map-tool-window-header-title">{{ title }}</span>
    <div class="map-tool-window-header-actions">
      <button 
        class="control-btn"
        @click="$emit('update:isHidden', !isHidden)" 
        :title="isHidden ? 'Expandir' : 'Minimizar'"
      >
        <!-- <font-awesome-icon :icon="isHidden ? 'plus' : 'minus'" /> -->
         <svg  v-if="isHidden"
         viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
         <svg v-else
          viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
      </button>
      <button 
        class="control-btn"
        @click="$emit('close')" 
        title="Cerrar"
      >
      <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        <!-- <font-awesome-icon icon="times" /> -->
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapToolHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    headerId: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.map-tool-header {
  background: linear-gradient(135deg, #0f4c75 0%, #3282b8 100%);
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
  //border-top-left-radius: 8px;
  //border-top-right-radius: 8px;
  user-select: none;
}

.tool-title {
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
}

.header-controls {
  display: flex;
  gap: 8px;
}

.control-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  color: white;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
}

.close-btn:hover {
  background: #e53935 !important;
}
</style>
